module.exports = __webpack_public_path__ + "static/media/cargas-gris.4b9f5de8.svg";